import theme from 'src/theme'
import styled from 'styled-components'

import { ModalType } from '../../types'

interface IRootSpanProps {
  modalPromptType?: ModalType
}

const errorStyles = `
.ant-btn-primary {
    background: ${theme.colors.red6} !important;
    border-color: ${theme.colors.red6} !important;

    &:hover {
      background: ${theme.colors.red5} !important;
    }
  }`

const RootSpan = styled.span<IRootSpanProps>`
  position: absolute;
  ${(props) => (props.modalPromptType === ModalType.ERROR ? errorStyles : '')}

  .ant-modal-content {
    padding: 32px 32px 28px;
  }
`

export { RootSpan }
